<div class="imprint-container">
  <div class="imprint-content">
    <h1 i18n="@@imprintTitle">Imprint</h1>

    <h2 i18n="@@siteCreditsTitle">Site Credits</h2>

    <h3 i18n="@@publisherTitle">Publisher</h3>
    <p i18n="@@publisherInfo">
      Published on behalf of the Rector of RWTH Aachen University.
    </p>
    <div i18n="@@universityAddress">
      <p>RWTH Aachen University</p>
      <p>Templergraben 55</p>
      <p>52062 Aachen (street address)</p>
      <p>52056 Aachen (mailing address)</p>
    </div>      
    <p>
      <span i18n="@@contactPhone">Phone</span>: +49 241 80 1<br>
      <span i18n="@@contactFax">Fax</span>: +49 241 80 92312<br>
      <span i18n="@@contactEmail">Email</span>: <a href="mailto:impressum@rwth-aachen.de">impressum@rwth-aachen.de</a>
    </p>
    <p i18n="@@rectorInfo">
      RWTH Aachen University is a public institution represented by the Rector, Univ.-Prof. Dr. rer. nat. Dr. h.c. mult. Ulrich Rüdiger.
    </p>

    <h3 i18n="@@regulatoryAuthorityTitle">Regulatory Authority</h3>
    <p i18n="@@regulatoryAuthorityInfo">
      The Ministry of Culture and Science of the Federal State of North Rhine-Westphalia, Völklinger Straße 49, 40221 Düsseldorf.
    </p>

    <h3 i18n="@@salesTaxTitle">Sales Tax Identification Number</h3>
    <p i18n="@@salesTaxInfo">
      In accordance with § 27 Sales Tax Law: DE 121689807
    </p>

    <h3 i18n="@@contentLiabilityTitle">Content Liability</h3>
    <div i18n="@@contentLiabilityInfo">
      <p>RWTH Lehr- und Forschungsgebiet Informatik 9 (Learning Technologies)</p>
      <p>RWTH Aachen University</p>
      <p>Ahornstraße 55</p>
      <p>52074 Aachen</p>
      <p>Phone: +49 241 80 21939</p>
      <p>Email: <a href="mailto:ali@informatik.rwth-aachen.de">ali@informatik.rwth-aachen.de</a></p>
    </div>    
  </div>
</div>
